var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('SiteMasthead',{attrs:{"mini":"true","title":"Lease Appraisal"}}),_c('ContentRow',[_c('ContentContainer',[_c('SectionTitle',[_vm._v("Lease Appraisal")]),_c('Form',{attrs:{"type":"Generic.VideoAppraisalRequestForm"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }